<template>
  <div class="location-search" v-bind:class="{ 'location-search--loading': loading }">

    <div class="location-search__loading" v-if="loading">
      Loading Results...
    </div>

    <div class="location-search-filters__container">
      <div class="location-search-filters">
        <label>Location</label>
        <div class="location-search-filters__inputs">
          <gmap-autocomplete class="location-search-filters__gmap-autocomplete location-search-filters__input"
            type="text"
            @place_changed="setPlaceValue"
            ></gmap-autocomplete>

          <button
            class="location-search-filters__button location-search-filters__button--geolocate button button--blue"
            v-on:click="geolocateUser"
            aria-label="Geolocate"
            >
            <span class="button-text">Geolocate</span>
            <svg v-svg
              symbol="sprite-icon-geolocate-light"
              size="0 0 14 14"
              role="presentation"
              ></svg>
          </button>
        </div>

        <div :class="geolocationMessage ? 'active' : ''" class="location-search-filters__message--geolocate">
          <p><strong>You do not have browser support enabled for automatic geolocation.</strong>
          This website must have SSL (https) and your browser specific settings for geolocation must be enabled for us to determine your current location.</p>
        </div>
      </div>


      <div class="location-search-filters location-search-filters__accordion">
        <input id="filters-accordion-input" type="checkbox" />
        <label class="button" for="filters-accordion-input">Filters</label>
        <article class="location-search-filters__accordion-content">
          <div class="location-search-filters__inputs">
            <div v-if="brandSearchEnabled" class="location-search-filters__input">
              <label>Brand</label>
              <autocomplete
                :callback="addFilterValue"
                :data="filterOptions.brands"
                field="value"
                name="brands"
                class="location-search-filters__autocomplete"
                placeholder="Search Brands"
                ></autocomplete>
              <svg v-svg
                symbol="sprite-icon-search"
                size="0 0 14 14"
                role="presentation"
                ></svg>
            </div>
            <div v-else class="location-search-filters__input--default-brand">
              <label>Brand</label>
              <div>{{ defaultBrand }}</div>
            </div>
            <div class="location-search-filters__input">
              <label>Location Type</label>
              <autocomplete
                :callback="addFilterValue"
                :data="filterOptions.types"
                field="value"
                name="types"
                class="location-search-filters__autocomplete"
                placeholder="Select a Location Type"></autocomplete>
            </div>
          </div>

          <div v-if="hasActiveFacets" class="location-search-filters__facets">
            <div v-for="(brand_value, i) in filters.brands" v-if="brand_value !== defaultBrand" class="location-search-filters__facet">
              <facet
                :callback="removeFilterValue"
                :value="brand_value"
                name="brands"></facet>
            </div>

            <div v-for="(type_value, i) in filters.types" class="location-search-filters__facet">
              <facet
                :callback="removeFilterValue"
                :value="type_value"
                name="types"></facet>
            </div>

            <button
              class="location-search-filters__button location-search-filters__button--clear-facet-all button button--blue"
              v-on:click="clearFacetValues">Clear</button>
          </div>
        </article>
      </div>



    </div>

    <div class="location-search-results" ref="locationMap">

      <location-map
        class="location-search-results__map"
        :markers="markers"
        :locationTypes="supportedLocationTypes"
        @interaction="handleMapInteraction"
      ></location-map>

      <div class="location-search-results__sidebar" ref="cardsContainer">

        <section class="location-search-results__content" ref="cards">

          <result-summary v-if="rawLocations.length > 0" :count="rawLocations.length"></result-summary>

          <div class="location-search-results__not-found" v-if="currentItemsLength === 0">
            <span v-if="hasPlace">
              No locations found, try expanding your search.
            </span>
            <span v-else>
              Enter your address to find locations near you.
            </span>
          </div>

          <div class="location-search-cards">
            <card
              class="card"
              v-for="location in cards"
              :key="location.id"
              :id="location.id"
              :name="location.name"
              :brands="location.brands"
              :types="location.types"
              :icontype="(supportedLocationTypes.includes(location.types[0])) ? location.types[0] : 'default'"
              :address="location.address"
              :city="location.city"
              :state="location.state"
              :zipcode="location.zipcode"
              :phone="location.phone"
            ></card>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Card from "./Card.vue";
import LocationMap from "./LocationMap.vue";
import ResultSummary from "./ResultSummary.vue";
import Autocomplete from "./Filters/Autocomplete.vue";
import Facet from "./Filters/Facet.vue";

const config = window.winebowLocatorConfig ? window.winebowLocatorConfig : {};

export default {
  components: {
    Card,
    LocationMap,
    ResultSummary,
    Autocomplete,
    Facet
  },
  mounted() {
    // test for geolocation capability
    this.geolocationEnabled = (location.protocol === 'https:' || location.hostname === 'localhost') && navigator.geolocation;

    // handle default brand version
    if(config.brandDefault !== undefined && config.brandDefault !== null) {
      this.brandSearchEnabled = false;
      this.defaultBrand = config.brandDefault;
    }

    // get facets list
    this.populateFilterOptions();
  },
  data() {
    return {
      filterOptions: {
        brands: [],
        types: []
      },
      geolocationEnabled: false,
      geolocationMessage: false,
      brandSearchEnabled: true,
      defaultBrand: null,
    };
  },
  methods: {
    handleMapInteraction() {
      // Scroll to map on mobile
      // const documentWidth = Math.max(
      //   document.body.scrollWidth,
      //   document.documentElement.scrollWidth,
      //   document.body.offsetWidth,
      //   document.documentElement.offsetWidth,
      //   document.documentElement.clientWidth
      // );
      // if (documentWidth <= 919) {
      //   const element = this.$refs.propertyMap;
      //   this.$scrollTo(element, 250);
      // }
    },
    populateFilterOptions() {
      // console.log('================================================');
      // console.log('BLUE ROVER', 'https://0mosudn32b.execute-api.us-east-1.amazonaws.com/search/facets');
      // console.log('BLUE ROVER BODY', '{}');
      // console.log('================================================');

      axios
        .post("https://0mosudn32b.execute-api.us-east-1.amazonaws.com/search/facets", {})
        .then(resp => {
          let types = [];
          let brands = [];

      // console.log('================================================');
      // console.log('BLUE ROVER RESP', resp);
      // console.log('================================================');

          if (resp.data.hasOwnProperty('payload')) {
            if (resp.data.payload.hasOwnProperty('aggregations')) {
              // Handle Property Types
              if (resp.data.payload.aggregations.hasOwnProperty('types')) {
                if (resp.data.payload.aggregations.types.hasOwnProperty('buckets')) {
                  //iterate over the location types
                  for(let facet of resp.data.payload.aggregations.types.buckets) {
                    types.push({
                      key: facet.key,
                      value: facet.key
                    });
                  }
                }
              }

              // Handle Brands
              if (resp.data.payload.aggregations.hasOwnProperty('brands')) {
                if (resp.data.payload.aggregations.brands.hasOwnProperty('buckets')) {
                  //iterate over the brands
                  for(let facet of resp.data.payload.aggregations.brands.buckets) {
                    brands.push({
                      key: facet.key,
                      value: facet.key
                    });
                  }
                }
              }
            }
          }

          types.sort((a, b) => (a.value > b.value) ? 1 : -1);
          brands.sort((a, b) => (a.value > b.value) ? 1 : -1);

          this.$set(this.filterOptions, "types", types);
          this.$set(this.filterOptions, "brands", brands);

          // Normalize and check default brand
          if(this.brandDefault !== null) {
            let normalizedBrand = this.defaultBrand.trim().toLowerCase();

            for(let brand of brands) {
              if(normalizedBrand === brand.value.trim().toLowerCase()) {
                this.defaultBrand = brand.value;
                this.$store.dispatch("setDefaultBrand", this.defaultBrand);
                break;
              }
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    addFilterValue(key, value) {
      this.$store.dispatch("addFilterValue", { key, value });
    },
    removeFilterValue(key, value) {
      this.$store.dispatch("removeFilterValue", { key, value });
    },
    clearFacetValues() {
      this.$store.dispatch("clearFilterValues");
    },
    setPlaceValue(location) {
      this.$store.dispatch("setPlace", location);
    },
    geolocateUser() {
      // HTML5 geolocation only works on https sites
      if (this.geolocationEnabled && navigator.geolocation) {
        this.geolocationMessage = false;
        navigator.geolocation.getCurrentPosition((position) => {
          // console.log('geolocateUser: ', position)
          this.$store.dispatch("setPlace", position);
        }, (err) => {
          console.log(err)
        });
      } else {
        this.geolocationMessage = true;
      }
    }
  },
  computed: {
    loading() {
      return this.$store.state.loading;
    },
    currentItemsLength() {
      return this.cards.length;
    },
    filters() {
      return this.$store.state.filters;
    },
    hasActiveFacets() {
      // are there any toggled facets

      return (this.$store.state.filters.brands.length > 1
        || this.$store.state.filters.brands.length > 0 && !this.$store.state.defaultBrand
        || this.$store.state.filters.types.length > 0);
    },
    hasPlace() {
      return this.$store.state.place !== null;
    },
    markers() {
      return this.$store.getters.markers;
    },
    cards() {
      return this.$store.getters.cards;
    },
    rawLocations() {
      return this.$store.state.locations;
    },
    supportedLocationTypes() {
      return this.$store.state.supportedTypes;
    }
  }
};
</script>
